var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Upload as AntUpload, message, Button, Icon, Modal as AntModal } from 'antd';
import classNames from 'classnames';
import { services } from '@comall-backend-builder/core';
import PropTypes from 'prop-types';
import { findIndex, map, cloneDeep, each, find, isEqual } from 'lodash';
import { Carousel } from '../carousel';
var AntDragger = AntUpload.Dragger;
/**
 * 图片上传的类型，multi: 上传多张, single: 上传单张
 */

var UploadFileTypeAPI;

(function (UploadFileTypeAPI) {
  UploadFileTypeAPI["multi"] = "multi";
  UploadFileTypeAPI["single"] = "single";
})(UploadFileTypeAPI || (UploadFileTypeAPI = {}));
/**
 * 上传组件的模式，
 */


var UploadFileModeAPI;

(function (UploadFileModeAPI) {
  UploadFileModeAPI["default"] = "default";
  UploadFileModeAPI["text"] = "text";
  UploadFileModeAPI["picture"] = "picture-card";
  UploadFileModeAPI["drag"] = "drag";
})(UploadFileModeAPI || (UploadFileModeAPI = {}));

var UploadFile = function (_super) {
  __extends(UploadFile, _super);

  function UploadFile(props) {
    var _this = _super.call(this, props) || this;

    _this.thisRef = null;
    var value = props.value;
    _this.state = {
      // 处理同步初始化数据
      fileList: value && value.length ? _this.conventValueToFileList(value) : [],
      previewImage: '',
      previewVisible: false,
      activePanel: 0
    };
    _this.localFileList = [];
    _this.handleComponentChange = _this.handleComponentChange.bind(_this);
    _this.handleFileListChange = _this.handleFileListChange.bind(_this);
    _this.handleCustomRequest = _this.handleCustomRequest.bind(_this);
    _this.handlePreview = _this.handlePreview.bind(_this);
    _this.handleCancel = _this.handleCancel.bind(_this);
    _this.handleBeforeUpload = _this.handleBeforeUpload.bind(_this);
    _this.renderImagePreview = _this.renderImagePreview.bind(_this);
    _this.conventValueToFileList = _this.conventValueToFileList.bind(_this);
    _this.renderLimitText = _this.renderLimitText.bind(_this);
    _this.changeSort = _this.changeSort.bind(_this);
    _this.setThisRef = _this.setThisRef.bind(_this);
    return _this;
  }
  /**
   * Upload组件的onChange方法
   * @param {object} info 上传的文件信息
   */


  UploadFile.prototype.handleComponentChange = function (info) {
    var _a = this.props,
        onUploadComplete = _a.onUploadComplete,
        uploadCompleteMessage = _a.uploadCompleteMessage,
        _b = _a.uploadType,
        uploadType = _b === void 0 ? UploadFileTypeAPI.single : _b;
    var fileList = [];
    var infoFileList = info.fileList;
    var status = info.file.status;

    if (uploadType === UploadFileTypeAPI.single) {
      if (infoFileList.length) {
        fileList = [infoFileList.pop()];
      }
    } else if (uploadType === UploadFileTypeAPI.multi) {
      fileList = infoFileList;
    }

    this.setState({
      fileList: fileList
    });

    if (status === 'removed') {
      this.handleFileListChange(fileList);
    } else if (status === 'done' || status === 'error') {
      if (status === 'done') {
        this.localFileList.push(info.file);

        if (infoFileList.every(function (item) {
          return item.status === 'done';
        })) {
          this.handleFileListChange(fileList);
        }
      }

      if (infoFileList.every(function (item) {
        return item.status === 'done' || item.status === 'error';
      })) {
        this.uploadCount = 0;
        var result = this.getComplateResult(this.uploadQueue, fileList);

        if (uploadCompleteMessage !== null) {
          var completeMessage = uploadCompleteMessage === undefined ? services.language.getText('components.UploadFile.uploadCompleteMessage') : uploadCompleteMessage;
          message.success(services.interpolate(completeMessage, {
            success: result.success + '',
            error: result.error + ''
          }));
        }

        if (onUploadComplete) {
          onUploadComplete(result);
        }

        this.uploadQueue = [];
      }
    }
  }; //获取本次的上传结果，成功数量、失败数量


  UploadFile.prototype.getComplateResult = function (uploadQueue, uploadResult) {
    var result = {
      success: 0,
      error: 0
    };
    each(uploadQueue, function (item) {
      var upload = find(uploadResult, function (i) {
        return i.uid === item.uid;
      });

      if (!upload) {
        return;
      }

      if (upload.status === 'done') result.success++;

      if (upload.status === 'error') {
        result.error++;
      }
    });
    return result;
  };
  /**
   * 调用表单的onChange方法
   * @param {array} fileList 上传列表里的文件数组
   */


  UploadFile.prototype.handleFileListChange = function (fileList) {
    var _a = this.props,
        onChange = _a.onChange,
        name = _a.name;
    var transformFileList;
    transformFileList = fileList.map(function (item) {
      return {
        id: item.response.id,
        path: item.response.path
      };
    });

    if (onChange) {
      onChange(transformFileList, name);
    }
  };
  /**
   * Upload组件的beforeUpload方法，用来检测当前上传是否超出最大限制
   * 以uploadCount计数本次上传的文件，在上传文件总数 = 最大限制数量 + 1时提示超限，当计数值达到本次上传总数时请零
   */


  UploadFile.prototype.handleBeforeUpload = function (file, fileList) {
    var _a = this.props,
        maxCount = _a.maxCount,
        maxSize = _a.maxSize,
        uploadLimitErrorMessage = _a.uploadLimitErrorMessage,
        uploadLimitSizeErrorMessage = _a.uploadLimitSizeErrorMessage,
        onUploadLimitSizeError = _a.onUploadLimitSizeError,
        onUploadLimitError = _a.onUploadLimitError;
    var uploadedLength = 0;
    var stateFileList = this.state.fileList;

    if (stateFileList && stateFileList.length) {
      uploadedLength = stateFileList.length;
    }

    if (!this.uploadCount) {
      this.uploadCount = 0;
    }

    this.uploadCount++;

    if (maxSize) {
      if (file.size > maxSize * 1024) {
        if (uploadLimitSizeErrorMessage !== null) {
          var errorMessage = uploadLimitSizeErrorMessage === undefined ? services.language.getText('components.UploadFile.uploadLimitSizeErrorMessage') : uploadLimitSizeErrorMessage;
          message.error(services.interpolate(errorMessage, {
            file: file,
            maxSize: maxSize
          }));
        }

        if (onUploadLimitSizeError) {
          onUploadLimitSizeError({
            file: file,
            maxSize: maxSize
          });
        }

        this.uploadCount--;
        return false;
      }
    }

    if (maxCount && uploadedLength + this.uploadCount > maxCount) {
      if (uploadedLength + this.uploadCount === maxCount + 1) {
        if (uploadLimitErrorMessage !== null) {
          var errorMessage = uploadLimitErrorMessage === undefined ? services.language.getText('components.UploadFile.uploadLimitErrorMessage') : uploadLimitErrorMessage;
          message.error(services.interpolate(errorMessage, {
            maxCount: maxCount
          }));
        }

        if (onUploadLimitError) {
          onUploadLimitError({
            maxCount: maxCount
          });
        }
      }

      if (this.uploadCount === fileList.length) {
        this.uploadCount = 0;
      }

      this.uploadCount--;
      return false;
    }

    return true;
  };

  UploadFile.prototype.handleCustomRequest = function (fileInfo) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, params, fileName, uploadUrl, file, data, config, response, e_1;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.props, params = _a.params, fileName = _a.fileName, uploadUrl = _a.uploadUrl;
            file = fileInfo.file;
            data = {
              files: file,
              otherParams: params
            };
            config = {
              progressCallBack: function progressCallBack(percent) {
                fileInfo.onProgress({
                  percent: percent
                }, file);
              },
              fileName: fileName,
              apiRoot: uploadUrl,
              apiPath: ''
            };
            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 4]);

            if (!this.uploadQueue) {
              this.uploadQueue = [file];
            } else {
              this.uploadQueue.push(file);
            }

            return [4
            /*yield*/
            , services.api.upload(data, config)];

          case 2:
            response = _b.sent();
            fileInfo.onSuccess({
              id: response.id,
              path: response.path
            }, file);
            return [3
            /*break*/
            , 4];

          case 3:
            e_1 = _b.sent();
            fileInfo.onError(e_1);
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * 点击预览图的回调
   */


  UploadFile.prototype.handlePreview = function (file) {
    var accept = this.props.accept;

    if (accept && accept.indexOf('image/') === 0) {
      this.setState({
        previewImage: file.url,
        previewVisible: true,
        activePanel: findIndex(this.state.fileList, file)
      });
    }
  };
  /**
   * 关闭Modal
   */


  UploadFile.prototype.handleCancel = function () {
    this.setState({
      previewVisible: false
    });
  };

  UploadFile.prototype.setThisRef = function (ref) {
    this.thisRef = ref;
  };

  UploadFile.prototype.componentDidUpdate = function () {
    this.handleSort();
  };

  UploadFile.prototype.componentDidMount = function () {
    this.handleSort();
  };

  UploadFile.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        style = _a.style,
        fileName = _a.fileName,
        accept = _a.accept,
        multiple = _a.multiple,
        uploadUrl = _a.uploadUrl,
        maxCount = _a.maxCount;
    var props = {
      name: fileName,
      action: uploadUrl,
      accept: accept,
      multiple: multiple,
      fileList: this.state.fileList,
      className: className,
      style: style,
      maxCount: maxCount,
      onChange: this.handleComponentChange,
      customRequest: this.handleCustomRequest,
      onPreview: this.handlePreview,
      beforeUpload: this.handleBeforeUpload
    };
    return React.createElement("div", {
      className: "upload-main",
      ref: this.setThisRef
    }, React.createElement("div", {
      className: "upload-content"
    }, this.renderUploadComponent(props)), maxCount ? this.renderLimitText() : null, this.renderImagePreview());
  };
  /**
   * 渲染文件上传限制提示文字
   */


  UploadFile.prototype.renderLimitText = function () {
    var _a = this.props,
        maxCount = _a.maxCount,
        limitTips = _a.limitTips;
    var limitText;
    var limitUnit;
    var style;
    var className;

    if (limitTips) {
      limitText = limitTips.limitText;
      limitUnit = limitTips.limitUnit;
      style = limitTips.style;
      className = limitTips.className;
    }

    var props = {
      style: style,
      className: classNames('upload-limit-text', className)
    };
    return React.createElement("div", __assign({}, props), limitText ? limitText : services.language.getText('components.UploadFile.uploadLimitText'), ' ', React.createElement("span", {
      className: "limit-count"
    }, maxCount), ' ', limitUnit ? limitUnit : services.language.getText('components.UploadFile.uploadLimitUnit'));
  };
  /**
   * 渲染预览，文件上传预览，使用modal，不使用popover
   */


  UploadFile.prototype.renderImagePreview = function () {
    var _a = this.state,
        previewVisible = _a.previewVisible,
        activePanel = _a.activePanel,
        fileList = _a.fileList;
    var preview = this.props.preview;
    var size;
    var autoplay;
    var showArrows;
    var dots;
    var easing;
    var effect;
    var vertical;

    if (preview) {
      size = preview.size;
      autoplay = preview.autoplay;
      showArrows = preview.showArrows;
      dots = preview.dots;
      easing = preview.easing;
      effect = preview.effect;
      vertical = preview.vertical;
    }

    var modalProps = {
      visible: previewVisible,
      footer: null,
      onCancel: this.handleCancel,
      width: size
    }; // 原数据集fileList需要格式化，在preview中显示

    var items = [];
    map(fileList, function (item, key) {
      var _a, _b;

      items.push(__assign({
        id: key,
        imageurl: item.url,
        text: item.url,
        component: ((_a = preview) === null || _a === void 0 ? void 0 : _a.component) || 'Image'
      }, (_b = preview) === null || _b === void 0 ? void 0 : _b.config));
    });
    var carouselProps = {
      className: 'modal-carousel',
      autoplay: autoplay,
      showArrows: showArrows,
      dots: dots,
      easing: easing,
      effect: effect,
      vertical: vertical,
      items: items,
      activePanel: activePanel
    };
    return React.createElement(AntModal, __assign({}, modalProps), React.createElement(Carousel, __assign({}, carouselProps)));
  };
  /**
   * 处理排序
   */


  UploadFile.prototype.handleSort = function () {
    var _a = this.props.sortable,
        sortable = _a === void 0 ? false : _a;

    if (!sortable) {
      return;
    }

    var wrap = ReactDOM.findDOMNode(this.thisRef);

    if (wrap === null) {
      return;
    }

    var containters = wrap.getElementsByClassName('ant-upload-list-picture-card-container');
    var actions = [];

    for (var i = 0, len = containters.length; i < len; i++) {
      var container = containters[i];

      if (container.className.indexOf('ant-upload-animate-inline-leave') === -1) {
        var actionContainer = container.querySelector('.ant-upload-list-item-actions');

        if (actionContainer) {
          actions.push(actionContainer);
        }
      }
    }

    if (actions.length === 0 || actions.length === 1) {
      return;
    }

    var _loop_1 = function _loop_1(i, len) {
      var action = actions[i];
      var sortContent = action.querySelector('.sort-content');
      var isFirst = i === 0;
      var isLast = i === len - 1;

      if (sortContent) {
        sortContent.remove();
      }

      sortContent = document.createElement('div');
      sortContent.className = 'sort-content';
      var left = document.createElement('span');

      if (!isFirst) {
        left.className = 'sort-left';
        left.title = services.language.getText('components.UploadFile.moveLeft');
        ReactDOM.render(React.createElement(Icon, {
          type: "arrow-left"
        }), left);
      } else {
        left.className = 'sort-left';
      }

      sortContent.appendChild(left);
      var right = document.createElement('span');

      if (!isLast) {
        right.className = 'sort-right';
        right.title = services.language.getText('components.UploadFile.moveRight');
        ReactDOM.render(React.createElement(Icon, {
          type: "arrow-right"
        }), right);
      } else {
        right.className = 'sort-right';
      }

      sortContent.appendChild(right);
      var changeSort = this_1.changeSort;

      (function (i) {
        if (!isFirst) {
          left.onclick = function (_e) {
            changeSort(i, -1);
          };
        }

        if (!isLast) {
          right.onclick = function (_e) {
            changeSort(i, 1);
          };
        }
      })(i);

      action.appendChild(sortContent);
    };

    var this_1 = this;

    for (var i = 0, len = actions.length; i < len; i++) {
      _loop_1(i, len);
    }
  };

  UploadFile.prototype.changeSort = function (index, direction) {
    var stateFileList = this.state.fileList;

    if (stateFileList && stateFileList.length) {
      var fileList = cloneDeep(stateFileList);
      var item = fileList.splice(index, 1)[0];
      fileList.splice(index + direction, 0, item);
      this.setState({
        fileList: fileList
      });
      this.handleFileListChange(fileList);
    }
  };

  UploadFile.prototype.componentWillReceiveProps = function (nextProps) {
    var newValue = nextProps.value;

    if (!isEqual(this.props.value, newValue)) {
      var fileList = this.conventValueToFileList(newValue);
      this.setState({
        fileList: fileList
      });
    }
  };
  /**
   * 转换value为Upload组件可识别的文件数据格式列表
   * @param   {array}   value 原数据集合
   * @returns {array}   Upload组件可识别的文件数据格式列表
   */


  UploadFile.prototype.conventValueToFileList = function (value) {
    var _this = this;

    var fileList = [];

    if (value && value.length) {
      fileList = value.map(function (valueItem) {
        return _this.getFileItemInfo(valueItem);
      });
    }

    return fileList;
  };
  /**
   * 获取上传文件列表的每一项文件的信息
   * @param {object} valueItem: 每一项文件的地址和id
   * @returns {object} 每一项文件的信息
   */


  UploadFile.prototype.getFileItemInfo = function (valueItem) {
    var localList = this.localFileList && this.localFileList.length ? this.localFileList.filter(function (item) {
      return item.response.id === valueItem.id;
    }) : [];

    if (localList && localList.length) {
      return Object.assign({}, localList[0], {
        url: localList[0].response.path
      });
    } else {
      var itemName = valueItem.path.split('/').pop();
      var status_1 = 'done';
      return {
        response: {
          id: valueItem.id,
          path: valueItem.path
        },
        url: valueItem.path,
        name: itemName,
        status: status_1,
        percent: 100,
        uid: valueItem.id,
        size: 0,
        type: ''
      };
    }
  };
  /**
   * 渲染上传组件
   * @param {object} componentProps 所要渲染组件的props
   */


  UploadFile.prototype.renderUploadComponent = function (componentProps) {
    var _a = this.props.mode,
        mode = _a === void 0 ? UploadFileModeAPI.default : _a;

    if (mode === UploadFileModeAPI.default) {
      Object.assign(componentProps, {
        listType: 'picture'
      });
      return this.getDefaultUpload(componentProps);
    } else if (mode === UploadFileModeAPI.text) {
      Object.assign(componentProps, {
        listType: 'text'
      });
      return this.getDefaultUpload(componentProps);
    } else if (mode === UploadFileModeAPI.drag) {
      Object.assign(componentProps, {
        listType: 'picture'
      });
      return this.getDragUpload(componentProps);
    } else if (mode === UploadFileModeAPI.picture) {
      Object.assign(componentProps, {
        listType: 'picture-card'
      });
      return this.getPictureCardUpload(componentProps);
    } else {
      return undefined;
    }
  };
  /**
   * 获取default和text模式的上传组件
   * @param {object} componentProps 所要渲染组件的props
   */


  UploadFile.prototype.getDefaultUpload = function (componentProps) {
    var uploadText = services.language.getText('components.UploadFile.toUpload');
    return React.createElement(AntUpload, __assign({}, componentProps), this.state.fileList.length >= componentProps.maxCount ? null : React.createElement(Button, null, React.createElement(Icon, {
      type: "upload"
    }), uploadText));
  };
  /**
   * 获取drag模式的上传组件
   * @param {object} componentProps 所要渲染组件的props
   */


  UploadFile.prototype.getDragUpload = function (componentProps) {
    var dragUploadText = services.language.getText('components.UploadFile.dragToUpload');
    return React.createElement(AntDragger, __assign({}, componentProps), React.createElement("p", {
      className: "ant-upload-drag-icon"
    }, React.createElement(Icon, {
      type: "inbox"
    })), React.createElement("p", {
      className: "ant-upload-text"
    }, dragUploadText));
  };
  /**
   * 获取picture-card模式的上传组件
   * @param {object} componentProps 所要渲染组件的props
   */


  UploadFile.prototype.getPictureCardUpload = function (componentProps) {
    return React.createElement(AntUpload, __assign({}, componentProps), this.state.fileList.length >= componentProps.maxCount ? null : React.createElement("div", null, React.createElement(Icon, {
      type: "plus"
    }), React.createElement("div", {
      className: "ant-upload-text"
    }, services.language.getText('components.UploadFile.upload'))));
  };

  UploadFile.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    // 属性路径
    name: PropTypes.string,
    // 选择完成后的回调
    onChange: PropTypes.func,
    // 默认已上传的图片
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    // 发到后台的文件参数名
    fileName: PropTypes.string,
    // 图片要上传的接口地址
    uploadUrl: PropTypes.string,
    // 接受上传的文件类型
    accept: PropTypes.string,
    // 图片上传的类型
    uploadType: PropTypes.oneOf([UploadFileTypeAPI.multi, UploadFileTypeAPI.single]),
    // 上传组件的模式
    mode: PropTypes.oneOf([UploadFileModeAPI.default, UploadFileModeAPI.text, UploadFileModeAPI.picture, UploadFileModeAPI.drag]),
    // 是否支持多选文件
    multiple: PropTypes.bool,
    // 上传最大数量
    maxCount: PropTypes.number,
    // 预览配置
    preview: PropTypes.object,
    // 结算文件大小限制 单位kb
    maxSize: PropTypes.number,
    //是否支持调整排序
    sortable: PropTypes.bool,
    //上传结束提醒信息
    uploadCompleteMessage: PropTypes.string,
    //超出文件大小限制提醒信息
    uploadLimitSizeErrorMessage: PropTypes.string,
    //超出数量限制提醒信息
    uploadLimitErrorMessage: PropTypes.string,
    //上传完成后回调
    onUploadComplete: PropTypes.func,
    //超出文件大小限制回调
    onUploadLimitSizeError: PropTypes.func,
    //超出数量限制回调
    onUploadLimitError: PropTypes.func
  };
  return UploadFile;
}(Component);

export { UploadFile };